module.exports = __webpack_public_path__ + "media/images/city_img/icon4-a74f23b1011938086815eacdc8c3f9d3.png";